import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import isEmpty from 'lodash/isEmpty';

import * as km from '../statistic/events';
import { SearchForm, Suggestion } from '../types';

const useSuggestionStatistic = ({
  isOpen,
  suggestions,
  suggestionsToShow,
  isEditMode,
  direction,
  debouncedInput,
  isLoading,
}: {
  isOpen: boolean;
  suggestions: Suggestion[];
  suggestionsToShow: Suggestion[];
  isEditMode: boolean;
  direction: 'departure' | 'destination';
  debouncedInput?: SearchForm['departure'] | SearchForm['destination'];
  isLoading: boolean;
}) => {
  const {
    formState: { errors },
  } = useFormContext<SearchForm>();
  const hasError = !isEmpty(errors[direction]);

  useEffect(() => {
    if (isOpen && suggestionsToShow.length > 0 && !isEditMode && !hasError) {
      km.trackSuggestionsOpen({ direction, suggestions: suggestionsToShow, input: debouncedInput });
    }
  }, [isOpen, suggestionsToShow, isEditMode, hasError]);

  useEffect(() => {
    if (
      isEditMode &&
      suggestions.length === 0 &&
      debouncedInput &&
      debouncedInput.length >= 2 &&
      !isLoading
    ) {
      km.trackEmptySuggestion({ input: debouncedInput, direction });
    }
  }, [isEditMode, suggestions, debouncedInput, isLoading]);
};

export default useSuggestionStatistic;
